import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-multi-signature',
  templateUrl: './multi-signature.component.html',
  styleUrls: ['./multi-signature.component.css']
})
export class MultiSignatureComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
